module.exports = __webpack_public_path__ + "media/EasySaude-Updates_Voz_Feminia.cec4856c.mp4";